import { styled } from '@mui/material/styles';
import SocialBtn from '../NoteInfo/SocialBtn';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { useLikeCommentMutation, useUnlikeCommentMutation } from '../../../../store/api/commentApi';
import { formatDateTime } from '../../../../utils/time';
import CommentDetails from './CommentDetails';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { DEFAULT_AVATAR } from '../../../../utils/constant';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const CommentContainer = styled('div')({
  display: 'flex',
  fontFamily: 'Raleway',
  fontSize: '13px',
  lineHeight: '15px',
  margin: '0',
  color: '#000000',
  '&>a': {
    overflow: 'hidden',
    height: '30px',
    width: '30px',
    margin: '3px 10px 0 0',
    display: 'block',
  },
});

const AuthorLink = styled('a')({
  textDecoration: 'none',
  cursor: 'pointer',
  color: 'initial',
});

const AuthorAvatar = styled('img')({
  height: '30px',
  width: '30px',
  objectFit: 'cover',
  borderRadius: '50%',
});

const CommentDetail = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(100% - 40px)',
});

const CommentAuthorRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '14px',
  lineHeight: '18px',
  '&>div': {
    display: 'flex',
    alignItems: 'center',
  },
});

const CommentAuthorDate = styled('div')({});

const CommentLike = styled('div')({
  width: '35px',
  justifyContent: 'space-between',
  '& button': {
    height: '22px',
    width: '17px',
    marginRight: '7px',
  },
  '& svg': {
    height: '22px',
    width: '17px',
  },
});

const AuthorName = styled('div')({
  paddingRight: '15px',
  fontFamily: 'Fjalla One',
});

const CommentDate = styled('div')({
  color: '#656666',
});

export default function Comment(props) {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  const { noteId, commentId, commentProps } = props;
  const { author, postAt, likedUsers } = commentProps;
  const linkUrl = `/user/${author.id}`;
  const [likeComment] = useLikeCommentMutation();
  const [unlikeComment] = useUnlikeCommentMutation();
  const currentUserId = useSelector(selectUser);
  const clickLike = async () => {
    if (likedUsers.includes(currentUserId)) {
      await unlikeComment({ noteId, commentId, unlikedUserId: currentUserId });
    } else {
      await likeComment({ noteId, commentId, likedUserId: currentUserId });
    }
  };
  const isBlock = !currentUserId || !isLogin;
  const clickToast = () => {
    if (isBlock) {
      toast.success('Please Sign in first.');
    }
    return;
  };

  return (
    <CommentContainer>
      <AuthorLink href={linkUrl} title={author.name}>
        <AuthorAvatar src={author.avatar || DEFAULT_AVATAR} alt={author.name} />
      </AuthorLink>
      <CommentDetail>
        <CommentAuthorRow>
          <CommentAuthorDate>
            <AuthorLink href={linkUrl} title={author.name}>
              <AuthorName>{author.name}</AuthorName>
            </AuthorLink>
            <CommentDate>{formatDateTime(postAt)}</CommentDate>
          </CommentAuthorDate>
          <CommentLike onClick={clickToast}>
            <SocialBtn onClick={clickLike} disabled={isBlock}>
              {isLogin && likedUsers.includes(currentUserId) ? (
                <ThumbUpAltIcon />
              ) : (
                <ThumbUpAltOutlinedIcon />
              )}
            </SocialBtn>
            {commentProps.likedUsers.length}
          </CommentLike>
        </CommentAuthorRow>
        <CommentDetails {...props} />
      </CommentDetail>
    </CommentContainer>
  );
}
